import React, { memo } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CompanyLogo from "../../../assets/svgIcons/company-logo.svg";
import { useNavigate } from "react-router-dom";


interface Props {
  isMobile: boolean;
}

const AvanseLogo = ({ isMobile }: Props) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, padding: isMobile ? "14px 0px": 0 }}>
    <img
      src={CompanyLogo}
      alt="Company Logo"
      style={{
        height: 40,
        objectFit: "contain",
      }}
    />
  </Box>
);


const NAV_ITEMS = [
  { label: "Support", path: "https://www.avanse.com/contact-us" },
  { label: "FAQs", path: "https://www.avanse.com/faq" },
];


const MainHeader: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const navigate = useNavigate();

  const onNavClick = (path: string) => {
    window.open(path, "_blank");
  };

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          bgcolor: "#ffffff",
          width: "100%",
          zIndex: (t) => t.zIndex.drawer + 1,
        }}
      >
        <Toolbar
          sx={{
            minHeight: { xs: 52, md: 80 },
            px: { xs: 2, md: 4 },
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* ── Left: Logo ── */}
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => navigate("/")}
          >
            <AvanseLogo isMobile={isMobile} />
          </Box>

          {/* ── Right: Nav + Icons ── */}
          {isMobile ? null : (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              {/* Nav links */}
              {NAV_ITEMS.map((item) => (
                <Button
                  key={item.label}
                  onClick={() => onNavClick(item.path)}
                  sx={{
                    color: "#475569",
                    fontWeight: 400,
                    fontSize: "0.875rem",
                    textTransform: "none",
                    px: 1.5,
                    py: 0.75,
                    borderRadius: 1.5,
                    letterSpacing: "0.01em",
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </>
  );
};

export default memo(MainHeader);
